export default __webpack_public_path__ + "static/palm-ba357e235b57da59e200a37a32b093c1.webp";